app.bind('default scrollToTop basic', context => {
    const $window = $(window);
    const $document = $(document);
    const $scrollButton = $('[js-scroll-to-top]', context);

    function visibilityFunction() {
        if ($window.scrollTop() > 50) {
            $scrollButton.addClass('is-visible');
        } else {
            $scrollButton.removeClass('is-visible');
        }
    }

    $document.on('ready',() => {
        visibilityFunction();

        $window.on('scroll', () => {
            visibilityFunction();
        });

        $scrollButton.on('click', (e) => {
            e.preventDefault();
            $('html, body').animate({scrollTop: 0 },'300');
        });

    });
});